// extracted by mini-css-extract-plugin
export default {"table-container":"PropertiesTable_table-container__nBCQL"};